<template>
  <section class="teacher__area pt-20 pb-110">
    <div class="container">
      <h4 class="leader__section-title mb-30">
        {{ $t("actions.information") }}
      </h4>
      <div class="row">
        <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-6 mb-30 mb-xl-0">
          <div class="leader__card text-center">
            <div class="leader__card-thumb">
              <img
                :src="
                  leader.image
                    ? baseUrl + leader.image
                    : require('../../assets/img/teacher/details/teacer-details-1.jpg')
                "
                alt=""
              />
            </div>
            <h5 class="leader__card-name">
              {{
                getName({
                  nameUz: leader.full_name_uz ?? "",
                  nameRu: leader.full_name_ru ?? "",
                  nameEn: leader.full_name_en ?? "",
                })
              }}
            </h5>
            <span class="leader__card-position">
              {{
                getName({
                  nameUz: leader.postion_uz ?? "",
                  nameRu: leader.postion_ru ?? "",
                  nameEn: leader.postion_en ?? "",
                })
              }}
            </span>
            <div class="leader__card-contact justify-start">
              <div v-if="leader.phone" class="leader__card-contact-item">
                <i class="fas fa-phone-alt"></i>
                <a :href="`tel:${leader.phone}`">{{ leader.phone }}</a>
              </div>
              <div v-if="leader.email" class="leader__card-contact-item">
                <i class="fas fa-envelope"></i>
                <a :href="`mailto:${leader.email}`">{{ leader.email }}</a>
              </div>
              <div class="leader__card-contact-item">
                <i class="fas fa-clock"></i>
                <span>
                  {{
                    getName({
                      nameUz: leader.res_uz ?? "",
                      nameRu: leader.res_ru ?? "",
                      nameEn: leader.res_en ?? "",
                    })
                  }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xxl-8 col-xl-8 col-lg-8">
          <div class="leader__card leader__card-tabs">
            <ul class="leader__tab-nav nav" id="leaderTab" role="tablist">
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link active"
                  id="bio-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#bio"
                  type="button"
                  role="tab"
                  aria-controls="bio"
                  aria-selected="true"
                >
                  {{ $t("actions.biography") }}
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  id="ilmiy-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#ilmiy"
                  type="button"
                  role="tab"
                  aria-controls="ilmiy"
                  aria-selected="false"
                >
                  {{ $t("actions.scientificActivity") }}
                </button>
              </li>
            </ul>
            <div class="tab-content leader__tab-content" id="leaderTabContent">
              <div
                class="tab-pane fade show active"
                id="bio"
                role="tabpanel"
                aria-labelledby="bio-tab"
              >
                <div v-html="bio"></div>
              </div>
              <div
                class="tab-pane fade"
                id="ilmiy"
                role="tabpanel"
                aria-labelledby="ilmiy-tab"
              >
                <div v-html="ilmiyFaoliyati"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import BlogMixin from "../../mixins/blogMixin";

export default {
  name: "InstructorDetailsArea",
  mixins: [BlogMixin],
  computed: {
    ...mapGetters("leader", ["leaderDetail"]),
    leader() {
      return this.leaderDetail || {};
    },
    bio() {
      return this.getName({
        nameUz: this.leader.biografiya_uz ?? "",
        nameRu: this.leader.biografiya_ru ?? "",
        nameEn: this.leader.biografiya_en ?? "",
      });
    },
    ilmiyFaoliyati() {
      return this.getName({
        nameUz: this.leader.ilmiy_faoliyati_uz ?? "",
        nameRu: this.leader.ilmiy_faoliyati_ru ?? "",
        nameEn: this.leader.ilmiy_faoliyati_en ?? "",
      });
    },
  },
  created() {
    this.getLeaderById(this.$route.query.id);
  },
  methods: {
    ...mapActions("leader", ["getLeaderById"]),
  },
};
</script>

<style scoped>
.leader__section-title {
  font-size: 22px;
  font-weight: 700;
  color: #0e1133;
  position: relative;
  padding-bottom: 12px;
}
.leader__section-title::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 40px;
  height: 3px;
  background: #30a820;
}

.leader__card {
  background: #fff;
  border: 1px solid #ececf0;
  border-radius: 10px;
  padding: 30px 24px;
}

.leader__card-thumb {
  width: 100%;
  margin: 0 auto 20px;
  border-radius: 8px;
  overflow: hidden;
}
.leader__card-thumb img {
  width: 100%;
  aspect-ratio: 3 / 4;
  object-fit: cover;
  object-position: center;
  border-radius: 8px;
}

.leader__card-name {
  font-size: 16px;
  font-weight: 700;
  text-transform: uppercase;
  color: #0e1133;
  margin-bottom: 6px;
}
.leader__card-position {
  display: block;
  color: #6f7180;
  margin-bottom: 20px;
}

.leader__card-contact {
  border-top: 1px solid #ececf0;
  padding-top: 20px;
}
.leader__card-contact-item {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 12px;
  font-size: 14px;
  color: #53545b;
}
.leader__card-contact-item:last-child {
  margin-bottom: 0;
}
.leader__card-contact-item i {
  color: #30a820;
  font-size: 14px;
}
.leader__card-contact-item a {
  color: #53545b;
}
.leader__card-contact-item a:hover {
  color: #30a820;
}

.leader__card-tabs {
  padding: 0;
  overflow: hidden;
}
.leader__card-tabs .leader__tab-nav {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0 24px;
  border-bottom: 1px solid #ececf0;
}
.leader__card-tabs .leader__tab-nav button {
  background: none;
  border: none;
  padding: 20px 16px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #9497a6;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  cursor: pointer;
  transition: all 0.3s;
}
.leader__card-tabs .leader__tab-nav button:hover {
  color: #0e1133;
}
.leader__card-tabs .leader__tab-nav button.active {
  color: #0e1133;
  border-bottom-color: #30a820;
}
.leader__tab-content {
  padding: 28px 24px;
  color: #53545b;
  line-height: 1.9;
}
</style>
